var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuStatbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 6,
    viewBox: "0 0 18 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 1.75L5.25 1.75V4.25L1.75 4.25V1.75ZM6.75 1.75V4.25L16 4.25C16.1123 4.25 16.1972 4.22632 16.25 4.20277V1.79723C16.1972 1.77368 16.1123 1.75 16 1.75L6.75 1.75ZM5.85342 5.73568C5.80124 5.74494 5.74598 5.75 5.6875 5.75H1.3125C0.763499 5.75 0.497316 5.30414 0.412435 5.12306C0.299529 4.8822 0.25 4.60217 0.25 4.33333V1.66667C0.25 1.39782 0.299529 1.1178 0.412435 0.876936C0.497316 0.695856 0.7635 0.25 1.3125 0.25H5.6875C5.74598 0.25 5.80124 0.255058 5.85342 0.264316C5.90083 0.254924 5.94984 0.25 6 0.25H16C16.4036 0.25 16.8028 0.357695 17.1231 0.571224C17.4382 0.781259 17.75 1.15378 17.75 1.66667V4.33333C17.75 4.84622 17.4382 5.21874 17.1231 5.42878C16.8028 5.64231 16.4036 5.75 16 5.75L6 5.75C5.94984 5.75 5.90083 5.74508 5.85342 5.73568Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuStatbar);
export default __webpack_public_path__ + "static/media/a11ymenu_statbar.56fb62abbade56e19cab58febb7e2c71.svg";
export { ForwardRef as ReactComponent };